import { useQuery } from '@apollo/client';
import { CONVERT_CURRENCY } from '../graphql/queries';
export function useCurrencyConversion(spec, skip) {
    const { data, loading, error } = useQuery(CONVERT_CURRENCY, {
        variables: { spec },
        skip: skip || !spec,
    });
    return {
        data: data?.convertCurrency,
        loading,
        error,
    };
}
